<div class="toast-contain">
    <div
        class="toast"
        *ngFor="let t of data"
        [ngClass]="{
            alert: t.alert,
            'toast-success': t.type == 'success',
            'toast-info': t.type == 'info',
            'toast-warning': t.type == 'warning',
            'toast-error': t.type == 'error'
        }"
    >
        <div class="toast-icon">
            <i
                class="fas"
                [ngClass]="{
                    'fa-check-circle': t.type == 'success',
                    'fa-info-circle': t.type == 'info',
                    'fa-exclamation-circle': t.type == 'warning',
                    'fa-exclamation-triangle': t.type == 'error'
                }"
            >
            </i>
        </div>
        <div class="toast-text" [ngClass]="{ 'non-alert-text': !t.alert }">{{ t.text }}</div>
        <div class="toast-dismiss" *ngIf="t.options?.dismiss">
            <span *ngIf="!t.options.actionText && !t.alert" (click)="dismiss(t)">Dismiss</span>
            <span
                *ngIf="t.options.actionText"
                [ngClass]="{
                    'toast-action-text': true
                }"
                (click)="takeAction(t)"
                >{{ t.options.actionText }}</span
            >
            <span
                *ngIf="t.alert || t.options?.actionAndDismiss"
                class="toast-dismiss-x"
                (click)="dismiss(t)"
            >
                <i class="fal fa-times"></i>
            </span>
        </div>
    </div>
</div>
